<template>
  <div>
    <!-- Gate stays mounted until the deck chunk is ready. After the user
         enters the password, the gate's Continue button keeps spinning
         while we await the async import — so there's never a blank /
         tiny-logo "loading" state between auth and the first slide. -->
    <InvestorPasswordGate
      v-if="!deckComponent && !loadError"
      :auth-scope="authScope"
      :storage-key="storageKey"
      :analytics-source="analyticsSource"
      @authenticated="handleAuthenticated"
    />

    <component :is="deckComponent" v-if="isAuthenticated && deckComponent" />

    <div v-if="loadError" class="investor-route-error">
      <div>Unable to load investor materials. Please refresh.</div>
      <div v-if="loadErrorDetail" class="investor-route-error-detail">
        {{ loadErrorDetail }}
      </div>
    </div>
  </div>
</template>

<script>
import { markRaw } from 'vue';
import InvestorPasswordGate from '@/components/InvestorPasswordGate.vue';

export default {
  name: 'InvestorGateRoute',
  components: { InvestorPasswordGate },
  props: {
    authScope: {
      type: String,
      required: true,
    },
    storageKey: {
      type: String,
      required: true,
    },
    analyticsSource: {
      type: String,
      required: true,
    },
    deckLoader: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      isAuthenticated: false,
      deckComponent: null,
      loadError: false,
      loadErrorDetail: '',
    };
  },
  methods: {
    async handleAuthenticated() {
      this.isAuthenticated = true;
      this.loadError = false;
      this.loadErrorDetail = '';

      if (this.deckComponent) return;

      try {
        const module = await this.deckLoader();
        this.deckComponent = markRaw(module.default || module);
      } catch (error) {
        this.loadError = true;
        this.loadErrorDetail = (error && error.message) || String(error);
        // eslint-disable-next-line no-console
        console.error('Unable to load investor deck', error);
      }
    },
  },
};
</script>

<style scoped>
.investor-route-error {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fafafa;
  color: #3b1a14;
  font-family: 'AirbnbCereal_W_Bk', -apple-system, BlinkMacSystemFont,
    sans-serif;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1.5rem;
  text-align: center;
}

.investor-route-error-detail {
  font-size: 0.75rem;
  color: rgba(60, 15, 9, 0.6);
  max-width: 90vw;
  word-break: break-word;
  white-space: pre-wrap;
}
</style>
